import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { Sizes } from "../../styles";

const EventsGrid = ({children}) => {
	return (
		<GridContainer>
			{children}
		</GridContainer>
	)
}

EventsGrid.propTypes = {
	children: PropTypes.any,
}

export default EventsGrid;

const GridContainer = styled.div`
    display: grid;
	grid-template-columns: 1fr;
	grid-gap: 3rem;

	@media only screen and (min-width: ${Sizes.screens.large}) {
		grid-template-columns: minmax(44rem, 1fr) minmax(0, 2fr);
		align-items: start;
	}
`;